import { create } from 'zustand';
import type { User } from '@lms/shared/types';

interface AuthState {
  token: string | null;
  user: User | null;
  isAuthenticated: boolean;
  setAuth: (token: string, user: User) => void;
  setTokens: (token: string) => void;
  logout: () => void;
}

const safeGetStorage = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const safeGetUser = (): User | null => {
  try {
    const raw = localStorage.getItem('participant_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const useAuthStore = create<AuthState>(set => ({
  token: safeGetStorage('participant_token'),
  user: safeGetUser(),
  isAuthenticated: Boolean(safeGetStorage('participant_token')),
  setAuth: (token, user) => {
    try {
      localStorage.setItem('participant_token', token);
      localStorage.setItem('participant_user', JSON.stringify(user));
      localStorage.removeItem('participant_refresh_token');
    } catch {
      // ignore
    }
    set({
      token,
      user,
      isAuthenticated: true,
    });
  },
  setTokens: token => {
    try {
      localStorage.setItem('participant_token', token);
      localStorage.removeItem('participant_refresh_token');
    } catch {
      // ignore
    }
    set({ token });
  },
  logout: () => {
    try {
      localStorage.removeItem('participant_token');
      localStorage.removeItem('participant_refresh_token');
      localStorage.removeItem('participant_user');
    } catch {
      // ignore
    }
    set({ token: null, user: null, isAuthenticated: false });
  },
}));
